import { Box } from '@mui/material';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints.js';

export const SubContent = ({ first, second }) => {
    const BoxStyle = {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        '& > *': {
            flex: 1,
            height: '100%',
        },
    };

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '32px',
                backgroundColor: 'unset !important',
                marginTop: '32px',
                alignItems: 'stretch',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    flexDirection: 'column',
                    marginTop: '20px',
                    gap: '20px',
                },
            }}
        >
            <Box sx={BoxStyle}>{first}</Box>
            <Box sx={BoxStyle}>{second}</Box>
        </Box>
    );
};
